import { Tooltip } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SizingTooltip = ({ title, children }) => (
  <>
    <Styles.TooltipStyle />
    <Tooltip title={title}>{children}</Tooltip>
  </>
)

export default SizingTooltip
